<script>
import { formatterMoney } from "@/utils";

export default {
  name: "ReportAccountStatusImportRemainRD",
  functional: true,
  props: {
    row: Object,
    column: String
  },
  render: function (createElement, context) {
    //const col = context.props.column;
    //const val = context.props.row[col];
    const rowValue = context.data.attrs.rowValue;
    const { ExpirationDate } = context.props.row;
    // console.log ("valor: ", val)
    // console.log("context: ", context)
    // console.log("date now biger: ", Date.now() > new Date(ExpirationDate))

    if (Date.now() > new Date(ExpirationDate) && rowValue !== 0) {
      return createElement(
        "span",
        {
          class: "text-danger"
        },
        formatterMoney(rowValue)
      );
    } else if (Date.now() < new Date(ExpirationDate) && rowValue !== 0) {
      return createElement(
        "span",
        {
          class: ""
        },
        formatterMoney(rowValue)
      );
    } else {
      return createElement("");
    }
  }
};
</script>

<style scoped>
.text-danger {
  color: red;
}
</style>
